import AnalyzeCondition from '@/components/page/PageAnalyze/AnalyzeCondition/AnalyzeCondition'

export default {
  name: 'ReservationDialog',
  components: {
    AnalyzeCondition: AnalyzeCondition
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    reservationPublishSettingFlag: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    editData: {
      memo: '',
      publishSetting: '0'
    }
  }),
  created () {
    console.log('ReservationDialog created!')
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    },
    onUpdate () {
      this.$emit('onUpdate', this.editData)
    }
  }
}
